module.exports = __webpack_public_path__ + "img/locked active.d5646643.svg";